function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

export var scaledToViewbox = function scaledToViewbox(rect, scale) {
  var width = rect.x2 - rect.x1;
  var height = rect.y2 - rect.y1;
  var x = rect.x1;
  var y = rect.y1;
  return {
    X: Math.floor(x / scale),
    Y: Math.floor(y / scale),
    Width: Math.floor(width / scale),
    Height: Math.floor(height / scale)
  };
};
export var normalizeChanges = function normalizeChanges(changes) {
  return changes.reduce(function (acc, change) {
    var pageNumber = change.position.pageNumber;
    var currentIndexPage = acc.findIndex(function (_ref) {
      var PageNumber = _ref.PageNumber;
      return pageNumber === PageNumber;
    });

    if (currentIndexPage < 0) {
      acc.push({
        PageNumber: pageNumber,
        PageWidth: change.position.pageSize.width,
        PageHeight: change.position.pageSize.height,
        Redactions: []
      });
      currentIndexPage = acc.length - 1;
    }

    var redactions = acc[currentIndexPage].Redactions;

    if (change.content.text) {
      change.position.rects.forEach(function (rect) {
        redactions.push(_extends({}, scaledToViewbox(rect, change.position.pageSize.scale), {
          Color: change.content.color
        }));
      });
    } else {
      var rect = change.position.boundingRect;
      redactions.push(_extends({}, scaledToViewbox(rect, change.position.pageSize.scale), {
        Color: change.content.color
      }));
    }

    return acc;
  }, []);
};
export var normalizePayload = function normalizePayload(changes, type, options) {
  if (type === void 0) {
    type = 'review';
  }

  if (options === void 0) {
    options = {};
  }

  var RedactedPages = normalizeChanges(changes);

  switch (type) {
    case 'review':
      {
        return _extends({
          Password: '',
          ReviewRedactions: true,
          GlyphCoverageThreshold: 30.0,
          RedactedPages: RedactedPages
        }, options);
      }

    case 'rereview':
      {
        return _extends({
          Password: '',
          ReviewRedactions: true,
          ForceRasterize: true,
          GlyphCoverageThreshold: 30.0,
          RedactedPages: RedactedPages
        }, options);
      }

    case 'redact':
      {
        return _extends({
          Password: '',
          FillColor: '#000000',
          GlyphCoverageThreshold: 30.0,
          ForceRasterize: false,
          RedactedPages: RedactedPages
        }, options);
      }

    default:
      {
        return _extends({
          RedactedPages: RedactedPages
        }, options);
      }
  }
};